// @ts-nocheck
export default {
    GET_WORKER_DELIVERY_FEE_GROUP_LIST: (state, data) => {
        state.workerDeliveryFeeGroupList = data;
    },
    GET_WORKER_CASH_AUTO_DEDUCT_GROUP_LIST: (state, data) => {
        state.workerCashAutoDeductGroupList = data;
    },
    CLEAR_WORKER_DELIVERY_FEE_GROUP_LIST: (state) => {
        state.workerDeliveryFeeGroupList = [];
    },
    CLEAR_WORKER_CASH_AUTO_DEDUCT_GROUP_LIST: (state) => {
        state.workerCashAutoDeductGroupList = [];
    },
};
